import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';

import { fetchProduct } from 'Redux/ducks/product';
import GeneralUtils from 'Helpers/GeneralUtils';
import { countryCode } from 'Helpers/Geo/data';
import FluidImg from 'Components/Utility/FluidImg';
import useViewport from 'Hooks/useViewport';

const AsterixMidPageBanner = () => {
  const [product, setProduct] = useState(null);

  const productSlug = 'asterix-obelix-xxl-romastered';

  useEffect(() => {
    const loadProduct = async () => {
      if (!productSlug) return false;

      return fetchProduct(productSlug)
        .then((result) => {
          if (result.notFound) {
            return false;
          }
          return setProduct(result.product);
        });
    };

    loadProduct();
  }, [productSlug]);

  const userLibrary = useSelector(state => state?.userLibrary);
  const steamLibrary = useSelector(state => state?.steamLibrary);

  const background = 'Welcome-To-Gaul-GIVEAWAY-MIDPAGE-BANNER-BACKGROUND.jpg';
  const foreground = 'Welcome-To-Gaul-GIVEAWAY-MIDPAGE-BANNER-FOREGROUND.png';
  const mobile = 'Welcome-To-Gaul-GIVEAWAY-MIDPAGE-BANNER-MOBILE.jpg';
  const { isAboveSm } = useViewport();

  const newUser = GeneralUtils.newUser();
  const canShowUserGiveawayBanner = newUser;
  const soldOut = _get(product, 'sold_out', false);
  const giveaway = _get(product, 'giveaway', false);
  const includedCodes = _get(product, 'regions_included', []).map(country => country.code);
  const excludedCodes = _get(product, 'regions_excluded', []).map(country => country.code);

  // Combine fanatical owned and steam owned
  const purchaseHistoryNames = [...userLibrary, ...steamLibrary];

  let lockedInRegion = false;
  if (excludedCodes.includes(countryCode)) lockedInRegion = true;
  if (!isEmpty(includedCodes) && !includedCodes.includes(countryCode)) lockedInRegion = true;

  const canShowUserProductBanner = !isEmpty(product) && !soldOut && !lockedInRegion;
  const isGiveawayBanner = !isEmpty(product) && !soldOut && !lockedInRegion && giveaway;

  if (
    isEmpty(product) ||
    !isGiveawayBanner ||
    purchaseHistoryNames.includes(product.name) ||
    !canShowUserProductBanner ||
    (!canShowUserGiveawayBanner)
  ) {
    return false;
  }

  return (
    <section>
      <Link to="/game/asterix-obelix-xxl-romastered">
        <div className="MidPageBanner">

          <div className="MidPageBanner__contentContainer">
            {isAboveSm &&
              <FluidImg
                src={foreground}
                alt={`${product?.name} - Giveaway`}
                overrideWidth="100"
                folder="assets"
                subfolder="banners/giveaway/asterix"
              />
            }
            <div className="MidPageBanner__background">
              <FluidImg
                src={isAboveSm ? background : mobile}
                alt="Sale Background"
                overrideWidth="100"
                folder="assets"
                subfolder="banners/giveaway/asterix"
              />
            </div>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default AsterixMidPageBanner;

